import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../services/api';
import notification from '../../../services/notification';
import types from '../../types';

function* getBnixFee() {
  try {
    const { status, data } = yield call(api.wallets.getBnixFee);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_BNIX_FEE_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_BNIX_FEE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

function* updateBnixFee({ payload }) {
  try {
    const { status, data } = yield call(api.wallets.updateBnixFee, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_BNIX_FEE_SUCCESS, payload: data });
    yield put({
      type: types.GET_BNIX_FEE_START,
      // payload: { level_id: payload?.fees[0]?.level_id },
    });
  } catch (error) {
    yield put({ type: types.UPDATE_BNIX_FEE_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Error. Please try again later.' });
  }
}

export function* bnixFee() {
  yield all([
    takeLatest(types.GET_BNIX_FEE_START, getBnixFee),
    takeLatest(types.UPDATE_BNIX_FEE_START, updateBnixFee),
  ]);
}
